module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAARCAYAAAAPFIbmAAAABGdBTUEAALGPC/xhBQAAAU9JREFUKBV1kLFLw0AUxt97JhdE6eqiztrBycVBN2f9A1ydHJ0kNE3TRQp2UkFXcenmf9Cpi4tgOziJUCmCLh3EtMk93x0kXJUe5PK93/vyXe4B/Fk/UcRpvX7nYnILoxFRM+Kjy2dM3G4vMjOh1ktzTdl4vGObRJtzTTnAIRI1JW1fHiyM5XEcx8tyzJECuJXuZ9Zs7v0zpVofC+xiHA+RuaXzvMWdzoIx2iRJWZWvQ+X7pwb6RPfAPEr7/Ux6RLJVJKXHRAnWaq/GBNUqMsCB1ZVK4KWIu1KsBZ73YKFs6WBwLckvQZJsGGZvMImiEw1wGSi1Dln2NWF+V0pVMQxHxmT/SSXJlUz6PJ1OuxNEc/3nwlCajAgajTOJfeI8v5FZ9QwrVjknAwjxQl4rMq+3wmC5W/hxXCR8u3wmqWwgbpVahOcWRpPnbftaf7j8F/HDej937xVmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/red-star-right@1x.png
// module id = 529
// module chunks = 46